import * as React from 'react'
import SettingsComponent from './Settings'

export const Settings = () => <SettingsComponent />
